import { Link, useLocation } from "react-router-dom";

const AdminDashboardContent = () => {
  const location = useLocation();
  const isActive = (path, exact = false) => {
    return exact
      ? location.pathname === path
      : location.pathname.startsWith(path);
  };
  return (
    <div className="p-5 flex-grow-1 dashboard_inner">
      <h1 className="fw-500 mb-2 ft-24">Hi, Cameron</h1>
      <p className="text-welcome fw-400 mb-4 ft-14">
        Welcome back to INP Dashboard
      </p>

      <div className="row g-4 mt-3">
        <div className="col-md-3">
          <Link
            to={"/adminDashboard/companies"}
            style={{ textDecoration: "none" }}
          >
            <div
              className={`card text-center ${
                isActive("/adminDashboard/companies") ? "active-tab" : ""
              }`}
            >
              <div className="card-body">
                <i className={`bi bi-buildings-fill`}></i>
                <p className="mt-4 lheading fw-500 ft-18">Companies</p>
              </div>
            </div>
          </Link>
        </div>
        <div className="col-md-3">
          <Link
            to={"/adminDashboard/inp-panel"}
            style={{ textDecoration: "none" }}
          >
            <div
              className={`card text-center ${
                isActive("/adminDashboard/inp-panel") ? "active-tab" : ""
              }`}
            >
              <div className="card-body">
                <i className={`bi bi-people-fill`}></i>
                <p className="mt-4 lheading fw-500 ft-18">INP Panel</p>
              </div>
            </div>
          </Link>
        </div>
        <div className="col-md-3">
          <Link
            to={"/adminDashboard/wallet"}
            style={{ textDecoration: "none" }}
          >
            <div
              className={`card text-center ${
                isActive("/adminDashboard/wallet") ? "active-tab" : ""
              }`}
            >
              <div className="card-body">
                <i className={`bi bi-wallet2`}></i>
                <p className="mt-4 lheading fw-500 ft-18">Wallet</p>
              </div>
            </div>
          </Link>
        </div>
        <div className="col-md-3">
          <Link
            to={"/adminDashboard/survey-management"}
            style={{ textDecoration: "none" }}
          >
            <div
              className={`card text-center ${
                isActive("/adminDashboard/survey-management")
                  ? "active-tab"
                  : ""
              }`}
            >
              <div className="card-body">
                <i className={`bi bi-clipboard-check-fill`}></i>
                <p className="mt-4 lheading fw-500 ft-18">Survey Management</p>
              </div>
            </div>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default AdminDashboardContent;
